import React, { useCallback, useEffect, useState } from "react";
import SVG from "src/utils/SVG";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { setNoticeRegister } from "../../store/reducers/noticeReduce";
import { useAppSelector } from "../../store/actions/action";

type StoreNames = "tempStores" | "beforeStores";

interface propsData {
  storeList: Store[];
  reduxName: StoreNames;
}
const FulfillListItem = (props: propsData) => {
  const [isCheckItems, setCheckItems] = useState<any>([]);
  const noticeData = useAppSelector((state) => state.noticeReduce);
  const [selectedStoreCount, setSelectedStoreCount] = useState(0);
  const dispatch = useDispatch();
  const handleAllCheck = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.target.checked) {
        const checkedListArray: any = [];

        props.storeList.forEach((list, idx) => checkedListArray.push(`check` + idx));

        setCheckItems(checkedListArray);
      } else {
        setCheckItems([]);
      }
    },
    [props.storeList],
  );

  const handleCheck = useCallback(
    (checked: any, id: any) => {
      if (checked) {
        setCheckItems([...isCheckItems, id]);
      } else {
        // 체크 해제
        setCheckItems(isCheckItems.filter((el: any) => el !== id));
      }
    },
    [isCheckItems],
  );

  function checkDeleteData(data: string) {
    return noticeData.beforeStores && noticeData.beforeStores.includes(data);
  }

  function allOnChange(e: React.ChangeEvent<HTMLInputElement>) {
    const reduxName = e.target.id.split("/")[0];
    if (e.target.checked) {
      //선택된 전체 리스트
      const allStore = props.storeList.map((store) => store.user_id);
      //기존에 가지고 있던 리스트 + 선택 추가된 리스트 (중복 제거)
      const insertStore = noticeData.beforeStores ? [...noticeData.beforeStores, ...allStore] : [...allStore];
      const uniqueArr = insertStore.filter((element, index) => {
        return insertStore.indexOf(element) === index;
      });
      dispatch(setNoticeRegister({ [props.reduxName]: uniqueArr }));
      if (reduxName === "tempStores") {
        dispatch(setNoticeRegister({ deleteTempStore: [] }));
      }
    } else {
      //선택해제된 전체 리스트
      const allStore = props.storeList.map((store) => store.user_id);
      // console.log(noticeData.stores && noticeData.stores.filter((store) => !allStore.includes(store)));
      //기존에 가지고 있던 리스트 - 선택 해제된 전체 리스트
      const deleteStore = noticeData.beforeStores && noticeData.beforeStores.filter((store) => !allStore.includes(store));
      dispatch(setNoticeRegister({ [props.reduxName]: deleteStore }));
      if (reduxName === "tempStores") {
        const deleteStore = props.storeList.map((store) => (checkDeleteData(store.user_id) ? store.user_id : null));
        dispatch(setNoticeRegister({ deleteTempStore: allStore }));
      }
    }
  }
  function onChange(e: React.ChangeEvent<HTMLInputElement>) {
    const reduxName = e.target.id.split("/")[0];
    const store = e.target.id.split("/")[1];
    if (noticeData !== undefined) {
      if (noticeData[props.reduxName]!.includes(store)) {
        const deleteArray = noticeData[props.reduxName]!.filter((res: string) => res !== store);
        dispatch(setNoticeRegister({ [props.reduxName]: deleteArray }));
        if (reduxName === "tempStores") {
          checkDeleteData(store) && dispatch(setNoticeRegister({ deleteTempStore: [...noticeData.deleteTempStore!, store] }));
        } else {
        }
      } else {
        const getStoreData = noticeData[props.reduxName];
        const plusArray = [...getStoreData!, store];
        dispatch(setNoticeRegister({ [props.reduxName]: plusArray }));
      }
    }
  }

  useEffect(() => {
    let temp = 0;
    props.storeList.forEach((store) => noticeData[props.reduxName] && noticeData[props.reduxName]!.includes(store.user_id) && temp++);
    setSelectedStoreCount(temp);
  }, [props.storeList, noticeData[props.reduxName]]);
  return (
    <FulfillItemSet>
      <div className="all-check">
        <div>
          {selectedStoreCount}/{props.storeList.length}
        </div>
        <div>
          <label className="all-label" htmlFor={props.reduxName + "/allCheck"}>
            전체선택
            {selectedStoreCount === props.storeList.length ? (
              <SVG name="roundCheckboxActive" width={24} height={24} viewBox="0 0 24 24" />
            ) : (
              <SVG name="roundCheckbox" width={24} height={24} viewBox="0 0 24 24" />
            )}
            <input type="checkbox" id={props.reduxName + "/allCheck"} checked={selectedStoreCount === props.storeList.length && true} onChange={allOnChange} />
          </label>
        </div>
      </div>
      <ul>
        {props.storeList?.map((store, idx) => {
          return (
            <li key={idx}>
              <label className="item-label" htmlFor={props.reduxName + "/" + store.user_id}>
                <span className="tag">{store.store_type_name}</span>
                <span className="title">
                  {store.name}
                  <span className="userId">{store.user_id}</span>
                </span>
                {noticeData[props.reduxName] && noticeData[props.reduxName]!.includes(store.user_id) ? (
                  <SVG name="roundCheckboxActive" width={24} height={24} viewBox="0 0 24 24" />
                ) : (
                  <SVG name="roundCheckbox" width={24} height={24} viewBox="0 0 24 24" />
                )}
                <input type="checkbox" id={props.reduxName + "/" + store.user_id} onChange={onChange} />
              </label>
            </li>
          );
        })}
      </ul>
    </FulfillItemSet>
  );
};

const FulfillItemSet = styled.div`
  .all-check {
    ${({ theme }) => theme.flexBox.flexMixin()}
    padding: 10px 15px;
    border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
  }
  label {
    position: relative;
    ${({ theme }) => theme.flexBox.flexMixin("row", "center", "center")}
    .tag {
      display: inline-block;
      width: 60px;
      height: 24px;
      line-height: 24px;
      border-radius: 12px;
      background-color: #f4f4f4;
      font-size: 14px;
      color: #60677d;
      text-align: center;
      flex-shrink: 0;
    }
    .title {
      flex-grow: 1;
      padding-left: 16px;
      ${({ theme }) => theme.textOverflow.singleLine()}
      font-size: 16px;
      font-weight: 700;
      .userId {
        position: relative;
        top: -1px;
        display: inline-block;
        margin-left: 8px;
        padding-left: 8px;
        border-left: 2px solid ${({ theme }) => theme.color.lineSecondary};
        color: ${({ theme }) => theme.color.quaternary};
        font-size: 14px;
        font-weight: 400;
      }
    }
    svg {
      flex-shrink: 0;
      margin-left: 13px;
    }
    input {
      overflow: hidden;
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      border: 0;
      margin: -1px;
      clip: rect(0 0 0 0);
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      -ms-appearance: none;
      -o-appearance: none;
    }
  }

  > ul {
    padding: 0 15px;
    > li {
      padding: 14px 0;
      border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
    }
  }
`;

export default FulfillListItem;
